export default {
  primary: {
    light: 'color.lightBlue',
    base: 'color.blue',
    dark: 'color.darkBlue',
    text: 'color.white',
  },
  secondary: {
    light: 'color.gray20',
    base: 'color.gray40',
    dark: 'color.gray50',
    text: 'color.gray80',
  },
  error: {
    light: 'color.lightRed',
    base: 'color.red',
    dark: 'color.darkRed',
    text: 'color.white',
  },
  success: {
    light: 'color.lightGreen',
    base: 'color.green',
    dark: 'color.darkGreen',
    text: 'color.white',
  },
  background: {
    light: 'color.gray20', // remove
    base: 'color.gray40',
    dark: 'color.gray50',
    text: 'color.gray70',
  },
  surface: {
    light: 'color.gray00', //remove
    base: 'color.gray00',
    dark: 'color.gray20',
    text: 'color.gray80',
  },
};
